import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { WorkspaceFeatures } from '../../../modules/chat/interfaces/IWorkspace';
import { PermissionsService } from '../../chat/services/permissions.service';

@Directive({
  selector: '[hasWorkspaceFeature]',
  standalone: false,
})
export class HasWorkspaceFeatureDirective {
  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<unknown>,
    private permissionsService: PermissionsService
  ) {}

  @Input() set hasWorkspaceFeature(features: WorkspaceFeatures[]) {
    if (this.permissionsService.checkWorkspaceFeatures(features)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
